<template lang="pug">
section.container-fluid.bg_blue.i_ptb_12.i_p_sm_0
  .container.i_m_sm_0
    .row.d-flex.flex-md-row-reverse
      .col-md-7.col-lg-7.i_p_sm_0.justify-content-end.align-items-center.d-flex
        .video
          iframe(
            ref="ytplayer",
            type="text/html",
            width="640",
            height="360",
            :src="youtubeUrl",
            frameborder="0",
            allowfullscreen
          )
      .col-md-5.col-lg-5
        .content
          h2.title {{ title }}
          p.i_body_l.i_mt_3(v-html="content")
          a.see_more_btn.sm.btn_blue_ci(:href="watchUrl", target="_blank") 看歷年廣告
</template>

<script>
export default {
  name: "AdVideo",
  props: {
    title: String,
    content: String,
    videoID: String,
    watchUrl: String,
  },
  data() {
    return {
      youtubeUrl: "",
    };
  },
  updated() {
    this.youtubeUrl = "https://www.youtube.com/embed/" + this.videoID;
  },
};
</script>

<style lang="scss" scoped>
// @import "@/assets/style/about_us/ad_video";
.video {
  width: 570px;
  position: relative;
  height: 0;
  padding-bottom: 56.25%;

  overflow: hidden;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

h2.title {
  @include font(36px, $color_blue_ci, normal);
}

.see_more_btn {
  position: absolute;
  bottom: 0;
}

@media (max-width: 991px) {
  .video {
    width: 370px;
  }

  h2.title {
    font-size: 24px;
  }
}

@media (max-width: 767px) {
  .container {
    max-width: 100%;
  }

  .video {
    width: 100%;
  }

  .col-md-5.col-lg-5 {
    padding-top: 40px;
    padding-bottom: 30px;
    padding: 40px 58px 30px 58px;
  }

  h2.title {
    font-size: 24px;
  }

  .see_more_btn {
    position: relative;
    margin-top: 40px;
  }
}

@media (max-width: 575px) {
  .video {
    @include size(100%, 54vw);
  }

  .col-md-5.col-lg-5 {
    padding-top: 7vw;
    padding-bottom: 5.2vw;
    padding: 7vw 10vw 5.2vw 10vw;
  }

  h2.title {
    font-size: 5.2vw;
  }

  p.i_body_l {
    font-size: 3.5vw;
    line-height: 7.35vw;
  }

  .see_more_btn {
    position: relative;
    margin-top: 7vw;
  }
}
</style>
